(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.schedule-a-call', ['pp.widgets-templates']);

ngModule.component('ppScheduleACall', {
    templateUrl: 'widgets/_angular/schedule-a-call/schedule-a-call.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);